import { ActionMessages, ACTIONS } from '@root/src/types/common';
import { formatFullName } from '@root/src/utils/formatters/strings';
import { UserFront } from './types';

export const userActionMessages: ActionMessages<UserFront> = {
  [ACTIONS.CREATE]: {
    successTitleKey: 'api.user.create.successTitle',
    successDescriptionKey: 'api.user.create.successDescription',
    formatMessage: data => ({ name: formatFullName(data.firstName, data.lastName) }),
  },
  [ACTIONS.UPDATE]: {
    successTitleKey: 'api.user.edit.successTitle',
    successDescriptionKey: 'api.user.edit.successDescription',
    formatMessage: data => ({ name: formatFullName(data.firstName, data.lastName) }),
  },
  [ACTIONS.DELETE]: {
    successTitleKey: 'api.user.delete.successTitle',
    successDescriptionKey: 'api.user.delete.successDescription',
    formatMessage: data => ({ name: formatFullName(data.firstName, data.lastName) }),
  },
};
